// @flow

// This should really be an enum, but flow does not support them out of the
// box, and we are not using Typescript yet.
export const ScribeCorrectionModeUnset = '';
type ScribeCorrectionModeUnsetType = '';

export const ScribeCorrectionModeFast = 'fast';
type ScribeCorrectionModeFastType = 'fast';

export const ScribeCorrectionModeAccurate = 'accurate';
type ScribeCorrectionModeAccurateType = 'accurate';

export const ScribeCorrectionModeDefault = ScribeCorrectionModeFast;

export type ScribeCorrectionMode =
  | ScribeCorrectionModeUnsetType
  | ScribeCorrectionModeFastType
  | ScribeCorrectionModeAccurateType;
